const rotate = keyframes`
	0% {
			transform: rotate(0deg);
	}
	100% {
			transform: rotate(360deg);
	}
`
import styled, { keyframes } from 'styled-components'

const Loader = styled.div`
  width: 48px;
  height: 48px;
  border: 5px solid black;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: ${rotate} 1s linear infinite;
`

export default Loader